var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#292D32;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_x2F_bold_x2F_search_00000121279126164263862580000004026733576021712007_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24,0L24,0v24H0V0H24z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_x2F_bold_x2F_search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "{props.color}",
    d: "M2,9.2V6.9C2,4.2,4.2,2,6.9,2h2.3C9.7,2,10,2.3,10,2.8S9.7,3.5,9.2,3.5H6.9 c-1.9,0-3.4,1.5-3.4,3.4v2.3c0,0.4-0.3,0.8-0.8,0.8C2.3,10,2,9.7,2,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000111889577371889890870000013930631145490582159_",
    fill: "{props.color}",
    d: "M20.5,9.2V6.9c0-1.9-1.5-3.4-3.4-3.4h-2.3 c-0.4,0-0.8-0.3-0.8-0.8S14.3,2,14.8,2h2.3C19.8,2,22,4.2,22,6.9v2.3c0,0.4-0.3,0.8-0.8,0.8C20.8,10,20.5,9.7,20.5,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000125567597948101346130000007302689572890306467_",
    fill: "{props.color}",
    d: "M15.7,22c-0.4,0-0.8-0.3-0.8-0.8 c0-0.4,0.3-0.8,0.8-0.8h1.4c1.9,0,3.4-1.5,3.4-3.4v-1.4c0-0.4,0.3-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8v1.4c0,2.7-2.2,4.9-4.9,4.9 H15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000181084848953094616830000017575063294637556616_",
    fill: "{props.color}",
    d: "M6.9,22C4.2,22,2,19.8,2,17.1v-2.3 C2,14.3,2.3,14,2.8,14s0.8,0.3,0.8,0.8v2.3c0,1.9,1.5,3.4,3.4,3.4h2.3c0.4,0,0.8,0.3,0.8,0.8S9.7,22,9.2,22H6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000104704861480448001400000005189055464144291491_",
    fill: "{props.color}",
    d: "M6.8,11.3c0,2.5,2,4.5,4.5,4.5 s4.5-2,4.5-4.5c0-2.5-2-4.5-4.5-4.5S6.8,8.8,6.8,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000066514483790953942300000002768715347951892927_",
    fill: "{props.color}",
    d: "M15.5,17c0,0-0.1-0.1-0.1-0.2 c0,0-0.1-0.1-0.1-0.2c0-0.1,0-0.1-0.1-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.3,0.1-0.4c0-0.1,0.1-0.2,0.2-0.3c0.2-0.2,0.6-0.3,0.9-0.3 c0.1,0,0.1,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0.1,0.3,0.1,0.4 c0,0.3-0.1,0.5-0.3,0.7c0,0-0.1,0.1-0.2,0.1c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.1,0-0.2,0 C16,17.2,15.7,17.1,15.5,17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000170998624012395326700000005666488796473882758_",
    fill: "none",
    d: "M0,24V0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldSearch);
export default __webpack_public_path__ + "static/media/vuesax-bold-search.5ea6d915cf89e0c31ba5b2004501393f.svg";
export { ForwardRef as ReactComponent };